import RecentTeaser from './RecentTeaser';
export default RecentTeaser;
